var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.796875 20.481V1.519C0.796875 1.169 0.884875 0.864 1.06087 0.602C1.23227 0.344187 1.46899 0.136456 1.74687 0L12.8279 11L1.74787 22C1.46999 21.8635 1.23327 21.6558 1.06187 21.398C0.885875 21.136 0.797875 20.83 0.797875 20.481H0.796875ZM16.3639 14.51L4.22787 21.424L13.7789 11.943L16.3649 14.51H16.3639ZM20.1109 9.69C20.5679 10.04 20.7969 10.476 20.7969 11C20.7969 11.524 20.5859 11.96 20.1639 12.31L17.5779 13.776L14.7279 11L17.5779 8.224L20.1109 9.69ZM4.22688 0.576L16.3639 7.49L13.7779 10.057L4.22787 0.577L4.22688 0.576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/play-store-logo.fb021a6cb257858698d48c35b1477850.svg";
export { ForwardRef as ReactComponent };